{
  "schemaVersion": 1,
  "slug": "slack",
  "name": "Slack",
  "description": "Give agents Slack tools or let people start and continue Paperclip work from Slack.",
  "categories": [
    "communication"
  ],
  "featured": true,
  "branding": {
    "logoUrl": "/brands/apps/slack.svg"
  },
  "urlPatterns": [
    "https://mcp.slack.com/*",
    "https://app.slack.com/client/*"
  ],
  "methods": [
    {
      "key": "mcp-oauth",
      "transport": "mcp_remote",
      "auth": "oauth",
      "ownershipModes": [
        "customer"
      ],
      "whenToUse": "Use the provider-hosted connection for the quickest setup.",
      "defaults": {
        "serverUrl": "https://mcp.slack.com/mcp",
        "authorizationEndpoint": "https://slack.com/oauth/v2/authorize",
        "tokenEndpoint": "https://slack.com/api/oauth.v2.access",
        "scopesHint": [
          "channels:read",
          "chat:write",
          "search:read"
        ]
      },
      "guidanceMd": "Connect a Slack workspace and limit access to the channels agents need.",
      "riskTier": "S3",
      "label": "Use this connection as an agent tool",
      "purpose": "tool",
      "requiredResourceFilters": [
        "workspace",
        "channel"
      ]
    },
    {
      "key": "chat-agent",
      "label": "Chat with an agent",
      "purpose": "channel",
      "provider": "slack",
      "transport": "chat_sdk",
      "auth": "api_key",
      "ownershipModes": [
        "customer"
      ],
      "whenToUse": "Let people in Slack start and continue work with one Paperclip agent.",
      "credentialFields": [
        {
          "key": "botToken",
          "label": "Bot User OAuth Token",
          "type": "password",
          "required": true,
          "placeholder": "xoxb-...",
          "secret": true
        },
        {
          "key": "signingSecret",
          "label": "Signing Secret",
          "type": "password",
          "required": true,
          "placeholder": "Paste the Slack App signing secret",
          "secret": true
        }
      ],
      "guidanceMd": "Create and install one Slack App for this agent. Paperclip receives verified Events API requests and interactive callbacks, acknowledges with reactions, responds in direct messages, and starts one Paperclip task per new mentioned channel thread.",
      "consoleLinks": {
        "register": "https://api.slack.com/apps",
        "docs": "https://api.slack.com/start/quickstart"
      },
      "riskTier": "S3",
      "requiredResourceFilters": [
        "workspace",
        "channel"
      ]
    }
  ]
}
